var nb = {
    rowsPerPageLabel: ['Vis', 'rader per side'],
    showing: function (start, end, total) {
        return "Viser ".concat(start, "-").concat(end, " av ").concat(total, " rader");
    },
    previous: 'Forrige',
    next: 'Neste',
    goToPage: function (page) { return "G\u00E5 til side ".concat(page); },
    currentPage: function (page) { return "Gjeldende side, side ".concat(page); },
};
var nn = {
    rowsPerPageLabel: ['Vis', 'rader per side'],
    showing: function (start, end, total) {
        return "Viser ".concat(start, "-").concat(end, " av ").concat(total, " rader");
    },
    previous: 'Forrige',
    next: 'Neste',
    goToPage: function (page) { return "G\u00E5 til side ".concat(page); },
    currentPage: function (page) { return "Gjeldande side, side ".concat(page); },
};
var en = {
    rowsPerPageLabel: ['Show', 'rows per page'],
    showing: function (start, end, total) {
        return "Showing ".concat(start, "-").concat(end, " of ").concat(total, " rows");
    },
    previous: 'Previous',
    next: 'Next',
    goToPage: function (page) { return "Go to page ".concat(page); },
    currentPage: function (page) { return "Current page, Page ".concat(page); },
};
export var txt = { nb: nb, nn: nn, en: en };
